import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "TwitterCircle",
  "use": "TwitterCircle-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"TwitterCircle\"><circle cx=\"16\" cy=\"16\" r=\"14\" fill=\"currentColor\" /><path d=\"M13 22.3c6.2 0 9.5-5.1 9.5-9.5v-.4c.7-.5 1.2-1.1 1.7-1.7-.6.3-1.2.4-1.9.5.7-.4 1.2-1.1 1.5-1.9-.6.4-1.4.7-2.1.8C21 9.4 20.1 9 19.1 9c-1.8 0-3.4 1.5-3.4 3.4 0 .3 0 .5.1.8-2.7-.2-5.2-1.6-6.8-3.6-.3.5-.5 1.1-.5 1.7 0 1.2.6 2.2 1.5 2.8-.5 0-1.1-.2-1.5-.4 0 1.6 1.2 3 2.7 3.3-.3.1-.6.1-.9.1-.2 0-.4 0-.6-.1.4 1.3 1.7 2.3 3.1 2.3-1.2.9-2.6 1.4-4.2 1.4h-.8c1.5 1 3.3 1.6 5.2 1.6\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol